
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useProgressEdit } from '@/modules/progress/model/edit';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.ITEM.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useProgressEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
